<template>
  <div class="box">
    <div class="big_box">
      <el-form
        ref="form"
        label-position="top"
        :rules="rules"
        :model="form"
        label-width="80px"
      >
        <el-form-item :label="titleLabel" prop="title">
          <el-input v-model="form.title" :placeholder="titleLabel"></el-input>
        </el-form-item>

        <template v-if="isaccept == 1">
          <el-form-item label="关键词 (3-5个, 回车分隔)" prop="keywords" required>
            <el-tag
              v-for="tag in dynamicTags"
              :key="tag"
              closable
              :disable-transitions="false"
              @close="handleClose(tag)"
            >
              {{ tag }}
            </el-tag>
            <el-input
              v-if="inputVisible"
              ref="saveTagInput"
              v-model="inputValue"
              class="input-new-tag"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            >
            </el-input>
            <el-button
              v-else-if="dynamicTags.length < 5"
              class="button-new-tag"
              size="small"
              @click="showInput"
            >+ 关键词</el-button>
          </el-form-item>

          <el-form-item label="摘要正文 (500-800字)" prop="remark" required>
            <el-input
              type="textarea"
              v-model="form.remark"
              placeholder="请输入摘要正文"
              maxlength="800"
              show-word-limit
            ></el-input>
          </el-form-item>
        </template>

        <el-form-item
                label="上传论文摘要全文 (中文):重新上传若未成功，则保留先前文件。"
                prop="fileurl"
                v-if="isaccept == 1"
        >
          <el-upload
                  v-model="form.fileurl"
                  class="upload-demo"
                  action="http://api.tg.lxmother.com/api/Files/send"
                  :on-preview="handlePreview"
                  :before-upload="beforeUpload"
                  :http-request="httpRequestMain"
                  :headers="headers()"
                  name="IMG_0390"
                  :limit="1"
                  :on-exceed="handleExceed"
                  :file-list="fileList"
                  accept=".doc,.docx"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip"  style=" display: inline-block ">
              （支持doc,docx格式文件）
            </div>
          </el-upload>
        </el-form-item>



        <el-form-item label="论文是否发表" prop="page_status" v-if="isaccept == 1">
          <el-radio v-model="form.page_status" label="1">未发表</el-radio>
          <el-radio v-model="form.page_status" label="2">近一年来已发表</el-radio>
        </el-form-item>

        <template v-if="form.page_status == 2">
          <el-form-item label="期刊名称"   prop="periodical_name" >
            <el-input v-model="form.periodical_name" placeholder="期刊名称"></el-input>
          </el-form-item>
          <el-form-item label="期刊号"  prop="periodical_number">
            <el-input v-model="form.periodical_number" placeholder="期刊号"></el-input>
          </el-form-item>
          <el-form-item label="期刊JCR分区"  prop="periodical_jcr">
            <el-input v-model="form.periodical_jcr" placeholder="期刊JCR分区"></el-input>
          </el-form-item>
          <el-form-item label="影响因子"  prop="periodical_factor">
            <el-input v-model="form.periodical_factor" placeholder="影响因子"></el-input>
          </el-form-item>
        </template>


        <el-form-item
          label="上传论文全文(中文):重新上传若未成功，则保留先前文件。"
          prop="extra_fileurl"
          v-if="isaccept == 1"
        >
          <el-upload
            v-model="form.extra_fileurl"
            class="upload-demo"
            action="http://api.tg.lxmother.com/api/Files/send"
            :on-preview="handlePreview"
            :before-upload="beforeUpload"
            :http-request="httpRequestMain2"
            :headers="headers()"
            name="IMG_0390"
            :limit="1"
            :on-exceed="handleExceed"
            :file-list="fileList"
            :accept="accept2"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip"  style=" display: inline-block ">
              （支持doc,docx,pdf格式文件）
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item
                label="上传作品:重新上传若未成功，则保留先前文件。"
                prop="fileurl"
                v-if="isaccept == 2"
        >
          <el-upload
                  v-model="form.fileurl"
                  class="upload-demo"
                  action="http://api.tg.lxmother.com/api/Files/send"
                  :on-preview="handlePreview"
                  :before-upload="beforeUpload"
                  :http-request="httpRequestMain"
                  :headers="headers()"
                  name="IMG_0390"
                  :limit="1"
                  :on-exceed="handleExceed"
                  :file-list="fileList"
                  accept=".doc,.docx,.mp4,.gif,.jpg,.jpeg,.png,.JPG,.PNG"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip" >
              （支持doc,docx,mp4,gif,jpg,jpeg,png,JPG,PNG格式文件）
            </div>
          </el-upload>
        </el-form-item>



        <el-form-item label="省份" prop="province" style=" display: inline-block ">
          <el-select
                  v-model="form.province1"
                  placeholder="请选择"
                  @change="changeCity"
          >
            <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="城市" prop="city" style=" margin-left: 50px;display: inline-block ">
          <el-select
                  v-model="form.city1"
                  placeholder="请选择"
                  @change="changeCity2"
          >
            <el-option
                    v-for="item in options1"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

      </el-form>
    </div>
    <div class="big_btn">
      <el-button
        :disabled="isDisable"
        v-loading="isDisable"
        element-loading-text="文件上传中"
        @click="nextSpet(1)"
        >下一步</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      isDisable: false,

      form: {
        fileurl: '',
        extra_fileurl: '',
        keywords: '',
        city1: '',
        city: '',
        province1: '',
        province: '',
        remark: '',
        page_status:'1',
          periodical_name:'',
          periodical_number:'',
          periodical_jcr:'',
          periodical_factor:'',
      },
      fileList: [],
      options: [],
      options1: [],
      value: '',
      isaccept: '',
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      accept2:'.doc,.docx,.pdf',
      accept:
        this.isaccept == 1
          ? '.doc,.docx'
          : '.doc,.docx,.mp4,.gif,.jpg,.jpeg,.png,.JPG,.PNG',
      rules: {
        title: [{ required: true, message: '请输入论文标题', trigger: 'blur' }],
        city1: [{ required: true, message: '请选择城市', trigger: 'change' }],
          fileurl: [{ required: true, message: '请选择文件', trigger: 'change' }],
//          extra_fileurl: [{ required: true, message: '请选择文件', trigger: 'change' }],

          periodical_name: [{ required: true, message: '请填写内容', trigger: 'change' }],
          periodical_number: [{ required: true, message: '请填写内容', trigger: 'change' }],
          periodical_jcr: [{ required: true, message: '请填写内容', trigger: 'change' }],
          periodical_factor: [{ required: true, message: '请填写内容', trigger: 'change' }],

        province1: [
          { required: true, message: '请选择省份', trigger: 'change' }
        ]
      }
    }
  },
  components: {},
  computed: {
    titleLabel() {
      return this.isaccept == 2 ? '作品标题' : '论文标题'
    }
  },
  created() {
    this.isaccept = window.localStorage.getItem('typeNum')
    this.rules.title[0].message = `请输入${this.titleLabel}`
    this.init()
  },


  methods: {
    async init() {
      let res = await this.$api.Home.getProvince()
      if (res.code == 0) {
        this.options = res.data.map((c, i) => {
          return { value: c.provinceid, label: c.province }
        })
      } else {
      }
    },
    async changeCity(val) {
      this.options.forEach(c => {
        if (c.value == val) {
          this.form.province = c.label
        }
      })

      let res = await this.$api.Home.getCity(val)
      if (res.code == 0) {
        this.options1 = res.data.map((c, i) => {
          return { value: c.cityid, label: c.city }
        })

        this.form.city1 = ''
      } else {
      }
    },
    changeCity2(val) {
      console.log(val)
      this.options1.forEach(c => {
        if (c.value == val) {
          this.form.city = c.label
        }
      })
    },
    submitUpload() {
      this.$refs.upload.httpRequestMain()
    },
    async httpRequestMain(f) {
      let param = new FormData() //创建form对象
      param.append('IMG_0390', f.file) //通过append向form对象添加数据
      let res = await this.$api.Home.upFile(param, 1)
      if (res.code == 0) {
        this.form.fileurl = res.data.url
        this.$message.success('文件上传成功')
        this.isDisable = false
      } else {
        this.$message.error('文件上传失败,请重新上传')
        this.isDisable = true
      }
    },

      async httpRequestMain2(f) {
          let param = new FormData() //创建form对象
          param.append('IMG_0390', f.file) //通过append向form对象添加数据
          let res = await this.$api.Home.upFile(param, 1)
          if (res.code == 0) {
              this.form.extra_fileurl = res.data.url
              this.$message.success('文件上传成功')
              this.isDisable = false
          } else {
              this.$message.error('文件上传失败,请重新上传')
              this.isDisable = true
          }
      },
    beforeUpload() {
      this.isDisable = true
      return true
    },
    headers() {
      return {
        Authorization: localStorage.getItem('token'),
        XAPIVERSION: 'V1'
      }
    },

    handlePreview(file) {
      console.log(file)
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      )
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
      this.form.keywords = this.dynamicTags.join(',')
    },
    showInput() {
      this.inputVisible = true
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm() {
      const inputValue = (this.inputValue || '').trim()
      if (inputValue) {
        if (this.dynamicTags.indexOf(inputValue) !== -1) {
          this.$message.warning('关键词不能重复')
        } else if (this.dynamicTags.length >= 5) {
          this.$message.warning('关键词最多5个')
        } else {
          this.dynamicTags.push(inputValue)
          this.form.keywords = this.dynamicTags.join(',')
        }
      }
      this.inputVisible = false
      this.inputValue = ''
    },

    nextSpet(val) {
      if (this.form.page_status == '2') {
        if (
          this.form.periodical_name == '' ||
          this.form.periodical_number == '' ||
          this.form.periodical_jcr == '' ||
          this.form.periodical_factor == ''
        ) {
          return this.$message.warning('请完善期刊信息')
        }
      }
      if (this.isaccept == 1) {
        if (this.dynamicTags.length < 3 || this.dynamicTags.length > 5) {
          return this.$message.warning('请填写3-5个关键词')
        }
        const remarkLen = (this.form.remark || '').trim().length
        if (remarkLen < 500 || remarkLen > 800) {
          return this.$message.warning('摘要正文请填写500-800字')
        }
        this.form.keywords = this.dynamicTags.join(',')
      }
      const skipKeys = [
        'keywords',
        'remark',
        'extra_fileurl',
        'periodical_name',
        'periodical_number',
        'periodical_jcr',
        'periodical_factor'
      ]
      for (const key in this.form) {
        if (skipKeys.indexOf(key) !== -1) {
          continue
        }
        if (this.form[key] == '') {
          this.$message.warning('请完善上面信息')
          return
        }
      }
      this.$emit('data1', this.form)
      this.$emit('nextSpet', val)
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-loading-spinner {
  top: 36% !important;
}
/deep/ .el-loading-spinner .circular {
    height: 34px !important;
    width: 34px !important;
}
/deep/.el-button--mini {
  margin-left: 10px;
}
/deep/.el-tag {
  margin-right: 10px;
  margin-bottom: 6px;
}
/deep/.el-tag--light {
  margin-left: 0;
}
.button-new-tag {
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 120px;
  margin-right: 10px;
  vertical-align: bottom;
}
/deep/.el-textarea__inner {
  min-height: 180px !important;
  max-width: 1100px !important;
  max-height: 180px !important;
  min-width: 1100px !important;
  border-radius: 5px;
}
.box {
  //   width: 1920px;
  //   height: 1572px;
  background-color: #f6fbff;
  .big_btn {
    width: 200px;

    margin: 0 auto;
    button {
      width: 200px;
      height: 60px;
      background-color: #00599e;
      border-radius: 5px;
      border: 0;
      color: #fff;
      margin-top: 40px;
      margin-bottom: 73px;
    }
  }
  .big_box {
    // margin: 0 auto;
    width: 1200px;
    // height: 1074px;
    background-color: #ffffff;
    padding: 50px;
    box-sizing: border-box;
  }
}
</style>
